import React from 'react';
import { ICustomizeButton } from '../../../../../models/try2Combo';
import styleClasses from '../../../try2.module.scss';
import { isItCreateYourOwnItem } from '../../../../../helpers/helperMethods';

const CustomizeButton: React.FC<ICustomizeButton> = ({ customizeModal, item }) => {
  const isDisabled = item?.is_customizable !== undefined && !item?.is_customizable && !isItCreateYourOwnItem(item.is_create_your_own);

  const handleCustomizeClick = (e:any) => {
      e.stopPropagation()
      customizeModal(item)
  }

  return (
    <button
      type="button"
      className={`${styleClasses.try2_item_order_btn} btn-large outline `}
      onClick={(e) => handleCustomizeClick(e)}
      disabled={isDisabled}
    >
      customize
    </button>
  );
};

export default CustomizeButton;
